export const COMPANY = 'company';
export const WAREHOUSE_ADMIN = 'warehouse';
export const GENERAL_USER = 'general';


// WEBPACK FOOTER //
// ./src/utils/userRoles.js